import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { useEffect } from "react";
import { useStore } from "../../../utils";
import Image from "react-bootstrap/Image";

function BrandIcon(props) {
  var icon = props.icon,
      otherProps = _objectWithoutProperties(props, ["icon"]);

  var store = useStore();

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      img = _React$useState2[0],
      setImg = _React$useState2[1];

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];

  useEffect(function () {
    var _store$styleCode;

    setLoading(true);
    var styleCode = (_store$styleCode = store.styleCode) === null || _store$styleCode === void 0 ? void 0 : _store$styleCode.toUpperCase();

    var success = function success(val) {
      setImg(val["default"]);
      setLoading(false);
    };

    var error = function error() {
      setImg(null);
      setLoading(false);
    };

    switch (styleCode) {
      case "LH":
        import("!!url-loader!dp-styles/app/images/assets/lh_assets/".concat(icon)).then(success, error);
        break;

      case "CS":
        import("!!url-loader!dp-styles/app/images/assets/ck_assets/".concat(icon)).then(success, error);
        break;

      case "BB":
        import("!!url-loader!dp-styles/app/images/assets/bb_assets/".concat(icon)).then(success, error);
        break;

      case "CB":
        import("!!url-loader!dp-styles/app/images/assets/cb_assets/".concat(icon)).then(success, error);
        break;

      case "EV":
        import("!!url-loader!dp-styles/app/images/assets/ev_assets/".concat(icon)).then(success, error);
        break;

      case "YH":
        import("!!url-loader!dp-styles/app/images/assets/yh_assets/".concat(icon)).then(success, error);
        break;

      case "CG":
        import("!!url-loader!dp-styles/app/images/assets/cg_assets/".concat(icon)).then(success, error);
        break;

      case "S52":
        import("!!url-loader!dp-styles/app/images/assets/52_assets/".concat(icon)).then(success, error);
        break;

      case "OG":
      default:
        import("!!url-loader!dp-styles/app/images/assets/og_assets/".concat(icon)).then(success, error);
        break;
    }
  }, [props.icon]);

  if (loading || !img) {
    return null;
  } else {
    return /*#__PURE__*/_jsx(Image, _objectSpread({
      src: img
    }, otherProps));
  }
}

export default BrandIcon;